import moment from "moment";
import { Order, OrderDetail } from "../../../services/order.service";
import React from "react";

type PrintOrderProps = {
  order: Order | undefined
  orderDetail: OrderDetail | undefined
}

const PrintOrder = React.forwardRef((
  { order, orderDetail }: PrintOrderProps, ref: any
) => {
  return (
    <div className="screen:hidden" ref={ref}>
      <div className="p-8 w-full text-center text-24">
        <div className="font-bold">{moment(order?.createdAt).format('DD MMM yyyy')}</div>
        <div><span className="font-bold">Order ID: </span>{order?.orderCode}</div>
        <div><span className="font-bold">Name: </span>{order?.user?.name || order?.customer?.name}</div>
        <div><span className="font-bold">Product Name: </span>{orderDetail?.product?.name}</div>
        <div><span className="font-bold">Quantity: </span>{orderDetail?.quantity}</div>
        <p>
          {
            orderDetail?.product?.cartConfigs?.map((config: any, index: number) => {
              return (
                config.key &&
                <span key={index} className="block">
                  <span className="font-semibold">{config.key}:</span> {config.value}
                </span>
              )
            })
          }
        </p>
      </div>
    </div>
  );
})

export default PrintOrder;